import { Injectable } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { catchError, firstValueFrom, map, Observable, Subscriber, tap, TeardownLogic, throwError } from 'rxjs';
import { MasterdataRequestDTO } from '../models/MasterdataRequestDTO.model';
import { FileDTO } from '../models/FileDTO.model';
import { DeviceDTO } from '../models/DeviceDTO.model';
import { PlanDeviceDTO } from '../models/PlanDeviceDTO.model';
import { ApiRoutesEnum } from '../shared/enums/ApiRoutes.enum';
import { MassImportSimsResponse } from '../models/MassImportSimsResponse';
import { ResponseDataFile } from '../shared/models/ApiResponse';
import { PlanAvailableDTO } from '../models/PlanAvailableDTO.model';
import { ResponseBase } from '../models/ResponseBase';
import { UnassignedCustomerDeviceDto } from '../models/UnassignedCustomerDeviceDto';
import { DataFile } from '../models/DataFile.model';
import { GetListPlansAvailablesRequest } from '../models/GetListPlansAvailablesRequest.model';
import { AlertService } from '../shared/services/alert.service';
import { AwaitableObservable, createAwaitable } from '../shared/AwaitableObservable';


@Injectable({
  providedIn: 'root',
})
export class InventoryService {
  constructor(private httpService: HttpService, private alertService: AlertService) {}

  getRatePlans() {
    return this.httpService.getRatePlans().pipe(tap((data) => {}));
  }

  createSim(simDTO: DeviceDTO) {
    return this.httpService.post<ResponseBase>(ApiRoutesEnum.CreateSim, simDTO).pipe(tap((data) => {}));
  }

  getListSims() {
    return this.httpService.getListSims().pipe(tap((data) => {}));
  }

  getAllDevices() {
    return this.httpService.post<DeviceDTO[]>(ApiRoutesEnum.GET_LIST_SIMS, {}).pipe(tap((data) => {}));
  }

  getAllUnassignedDevices(isUserPlan : boolean) {
    return this.httpService.post<DeviceDTO[]>(ApiRoutesEnum.getAllUnassignedDevices + isUserPlan, {}).pipe(tap((data) => {}));
  }

  updateSimStatus(sim: DeviceDTO) {
    return this.httpService.updateSimStatus(sim).pipe(tap((data) => {}));
  }

  updateSim(sim: DeviceDTO) {
    return this.httpService.post<ResponseBase>(ApiRoutesEnum.UPDATE_SIM, sim).pipe(tap((data) => {}));
  }

  getMastersByName(data: MasterdataRequestDTO) {
    return this.httpService.getMastersByName(data).pipe(tap((data) => {}));
  }

  importSims(file: FileDTO) {
    return this.httpService.post<MassImportSimsResponse>(ApiRoutesEnum.IMPORT_SIMS,file).pipe(tap((data) => {}));
  }

  getListSimsAvailables() {
    return this.httpService.getListSimsAvailables().pipe(tap((data) => {}));
  }

  getListPlansAvailables(customerId?: number) {
    return this.httpService.post<PlanAvailableDTO[]>(ApiRoutesEnum.GetListPlansAvailables, <GetListPlansAvailablesRequest>{customerId}).pipe(tap((data) => {}));
  }

  updatePlanDevicesAsync(data: PlanDeviceDTO[]) {
    const res = this.httpService.post<ResponseBase>(ApiRoutesEnum.UpdatePlanDevices, data).pipe(tap(data => {}));
    return this.alertService.createAwaitableResponseBase(res);
  }

   transferUnassignedCustomerDevices(data: UnassignedCustomerDeviceDto[]) {
    return this.httpService.post<ResponseBase>(ApiRoutesEnum.transferUnassignedCustomerDevices ,data).pipe(tap((data) => {}));
  }

  revertDedviceTransferFromCustomer(data: UnassignedCustomerDeviceDto[]) {
    return this.httpService.post<ResponseBase>(ApiRoutesEnum.revertDedviceTransferFromCustomer ,data).pipe(tap((data) => {}));
  }

   revertDedviceTransferFromUserPlan(data: UnassignedCustomerDeviceDto[]) {
    return this.httpService.post<ResponseBase>(ApiRoutesEnum.revertDedviceTransferFromUserPlan ,data).pipe(tap((data) => {}));
  }


  getStatusSims() {
    return this.httpService.getStatusSims().pipe(tap((data) => {}));
  }

  getCarriers() {
    return this.httpService.getCarriers().pipe(tap((data) => {}));
  }

  getLogsCalback(data: DeviceDTO) {
    return this.httpService.getLogsCalback(data).pipe(tap((data) => {}));
  }

  updateSims(file: FileDTO) {
    return this.httpService.post<MassImportSimsResponse>(ApiRoutesEnum.UPDATE_SIMS,file).pipe(tap((data) => {}));
  }
  
  getTemplateUpdateInventory(){
    return this.httpService.getTemplateUpdateInventory().pipe(
      tap((data) => {
      })
    );
  }

  getTemplateCreateInventory(){
    return this.httpService.getTemplateCreateInventory().pipe(
      tap((data) => {
      })
    );
  }

  exportToExcelListOfInventory(data: DeviceDTO[]){
    return this.httpService.post<DataFile>(ApiRoutesEnum.ExportToExcelListOfInventory,data).pipe(
      tap((data) => {
      })
    );
  }


  GenericExportToExcel(request: any){
    return createAwaitable(this.httpService.post<DataFile>(ApiRoutesEnum.GenericExportToExcel,request));
  }

  getDeviceByIccid(iccid? :string){
    return this.httpService.get<DeviceDTO>(ApiRoutesEnum.GetDeviceByIccid+iccid).pipe(
      tap((data) => {
      })
    );                                            
  }

}
